import { Injectable } from '@angular/core';

import { TrackingItem, TrackingType } from '@stylehaven/components';
import { TrackingProviderService } from '../_base-tracking-provider.service';

declare global {
    interface Window {
        ga: any;
    }
}
@Injectable()
export class GoogleAnalyticsService extends TrackingProviderService {
    private currentTrackingItems: TrackingItem[];

    public init(trackingItems: TrackingItem[]): void {
        this.currentTrackingItems = trackingItems;

        if (this.currentTrackingItems && this.currentTrackingItems.length > 0) {
            this.includeAnalyticsScript();
            this.initTrackingItems();
        }
    }

    public registerPageView(currentUrl: string): void {
        for (const trackingItem of this.currentTrackingItems) {
            (<any>window).ga(`${trackingItem.name}.set`, 'page', currentUrl);
            (<any>window).ga(`${trackingItem.name}.send`, 'pageview', { anonymizeIp: true });
        }
    }

    private initTrackingItems(): void {
        for (const trackingItem of this.currentTrackingItems) {
            if (trackingItem.type === TrackingType.GA) {
                this.setupGoogleAnalyticsObject(trackingItem);
                this.includeGoogleTagManagerScript(trackingItem.id);
                this.includeGoogleTagScript(trackingItem.id);
            }
        }
    }

    private includeAnalyticsScript(): void {
        const scriptElement: HTMLScriptElement = document.createElement('script');
        scriptElement.id = 'google-analytics';
        scriptElement.async = true;
        scriptElement.src = 'https://www.google-analytics.com/analytics.js';

        const htmlHeadElement: HTMLHeadElement = document.getElementsByTagName('head')[0];
        htmlHeadElement.appendChild(scriptElement);
    }

    private includeGoogleTagManagerScript(id: string): void {
        const scriptElement: HTMLScriptElement = document.createElement('script');
        scriptElement.id = 'google-tag-manager';
        scriptElement.async = true;
        scriptElement.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;

        const htmlHeadElement: HTMLHeadElement = document.getElementsByTagName('head')[0];
        htmlHeadElement.appendChild(scriptElement);
    }

    private includeGoogleTagScript(id: string): void {
        const scriptElement: HTMLScriptElement = document.createElement('script');
        scriptElement.id = 'google-analytics-config';
        scriptElement.text = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', '${id}');
        `;

        const htmlHeadElement: HTMLHeadElement = document.getElementsByTagName('head')[0];
        htmlHeadElement.appendChild(scriptElement);
    }

    private setupGoogleAnalyticsObject(trackingItem: TrackingItem): void {
        window.ga =
            window.ga ||
            function () {
                (window.ga.q = window.ga.q || []).push([]);
            };
        window.ga.l = +new Date();

        window.ga('create', {
            trackingId: trackingItem.id,
            name: trackingItem.name,
            anonimizeIp: true
        });
        window.ga(`${trackingItem.name}.set`, 'anonymizeIp', true);
    }
}
